<div class="metric-target-and-timeleft">
  <div class="metric-bar-target">
    {{ metric | metric : "targets" : { additionalInfo: "", withoutRounding: true } }}
    <span> {{ "current_progress_at" | localize }} {{ metric | metric : "actual" : { additionalInfo: "formatted", withoutRounding: true } }}</span>
    <span *ngIf="metric.insightName !== ''">, {{ "dynamic_metric_lower" | localize }}</span>
    <span *ngIf="metric.cascadeType.length">, {{ "a_cascaded_key_result" | localize }}</span>
    <div class="timeleft" *ngIf="metric.percentTime">{{ metric | metric : "dueDates" }}</div>
  </div>
</div>
